export const SHARING_AGREEMENTS_REPORT_V1_PATH =
    '/api/v1/trustcenter/provider/sharing-agreements-report';

export const SHARING_AGREEMENTS_REPORT_V2_PATH =
    '/data-sharing/v2/sharing-agreements/sharing-agreements-report';

const configuredReportUrl = (path) => {
    const apiHost = window.config?.API_URL;
    if (!apiHost) {
        return path;
    }
    return `https://${apiHost}${path}`;
};

/**
 * Optional local overrides in public/config/config.js (do not commit secrets):
 *   SHARING_AGREEMENTS_REPORT_V1_URL: 'http://localhost:8092/api/v1/trustcenter/provider/sharing-agreements-report'
 *   SHARING_AGREEMENTS_REPORT_V2_URL: 'http://localhost:5091/data-sharing/v2/sharing-agreements/sharing-agreements-report'
 */
export const V1_SHARING_AGREEMENTS_REPORT_URL =
    window.config?.SHARING_AGREEMENTS_REPORT_V1_URL ||
    configuredReportUrl(SHARING_AGREEMENTS_REPORT_V1_PATH);

export const V2_SHARING_AGREEMENTS_REPORT_URL =
    window.config?.SHARING_AGREEMENTS_REPORT_V2_URL ||
    configuredReportUrl(SHARING_AGREEMENTS_REPORT_V2_PATH);

export const isSharingAgreementsReportRequest = (config) => {
    const url = config?.url || '';
    return (
        url.includes(SHARING_AGREEMENTS_REPORT_V1_PATH) ||
        url.includes(SHARING_AGREEMENTS_REPORT_V2_PATH)
    );
};

/** Direct localhost API overrides bypass Kong and use x-credential-jwt instead of Bearer. */
export const isLocalReportUrl = (url) =>
    /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i.test(url || '');

export const isLocalReportRequest = (config) => isLocalReportUrl(config?.url);
